import { baseApi } from './baseApi';
import type {
  AuditLog,
  AuditLogFilters,
  AuditStatistics,
} from '../../types/api';

interface AuditLogResponse {
  logs: AuditLog[];
  total: number;
  limit: number;
  offset: number;
}

export const auditLogApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    listAuditLogs: builder.query<AuditLogResponse, AuditLogFilters>({
      query: (filters) => ({
        url: '/audit-logs',
        params: filters,
      }),
      providesTags: ['AuditLogs'],
    }),

    getAuditStatistics: builder.query<AuditStatistics, void>({
      query: () => '/audit-logs/statistics',
      providesTags: ['AuditLogs'],
    }),
  }),
});

export const {
  useListAuditLogsQuery,
  useGetAuditStatisticsQuery,
} = auditLogApi;
